import { Routes, Route, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Login from './Login';
import Chat from './Chat';
import PrivateRoute from './PrivateRoute';


export default function App() {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  
  
  const handleLogin = (user: any, token: string) => {
    setCurrentUser(user);
    localStorage.setItem('token', token);
    navigate('/chat');
  };

  return (
    <Routes>
      <Route path="/" element={<Login onLogin={handleLogin} />} />
      <Route path="/chat" element={
        <PrivateRoute>
          <Chat user={currentUser}  onLogout={() => setCurrentUser(null)} />
        </PrivateRoute>
      } />
    </Routes>
  );
}
